let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("53UTJ")).then(() => parcelRequire('6IVyQ'));